import { CSSProperties } from "react";
import styled, { keyframes } from "styled-components";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

const blinkEmpty = keyframes`
    30%, 75% {
      background-size: 1px 1.2em;
    }
    50% {
      background-size: 0 1.2em;
    }
  `;

export const BlinkingCursor = styled.input`
  all: unset;
  height: 100%;
  width: 25%;
  margin-left: 50%;
  background-image: linear-gradient(
    ${({ theme }) => theme.input.text},
    ${({ theme }) => theme.input.text}
  );
  background-position: 1px center;
  background-repeat: no-repeat;
  background-size: 1px 1.2em;
  animation: ${blinkEmpty} 1s infinite;

  &:focus {
    background-image: none;
  }
`;

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
    },
    codeInputContainer: {
      justifyContent: "center",
      alignItems: "center",
      height: 62,
      width: 48,
      borderRadius: constants.radius.view,
      marginLeft: spacing.xxs,
      marginRight: spacing.xxs,
      backgroundColor: theme.input.background,
    },
    codeInput: {
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    text: {
      textAlign: "center",
      fontSize: 22,
    },
    empty: {
      all: "unset",
      height: "100%",
      width: "50%",
      marginLeft: "50%",
    },
    hidden: {
      opacity: 0,
    },
  };

  return styles;
};
